"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetUserHoldingView = void 0;
class GetUserHoldingView {
    constructor(holdingRepository) {
        this.holdingRepository = holdingRepository;
    }
    execute(request) {
        return this.holdingRepository.getUserHoldingView(request);
    }
}
exports.GetUserHoldingView = GetUserHoldingView;
